import { requests } from '../../../api/services';
import { LIST_CAMPAIGN_EMAILING_URL } from '../../../utils/Endpoints';
import { EmailRequest } from '../../../model/email/EmailRequest';
import { ICampaignEmailing } from '../../../model/campaign/ICampaignEmailing';

export const CampaignEmailingService = {
    getCampaignEmailing: (id: number): Promise<ICampaignEmailing> =>
        requests.get(`${LIST_CAMPAIGN_EMAILING_URL}/${id}`),
    sendEmails: (id: number, body: EmailRequest) => requests.post(`${LIST_CAMPAIGN_EMAILING_URL}/${id}`, body),
};
